import React, { useEffect, useState } from "react";
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "react-bootstrap";
import PDFViewerTool from "../tools/pdf-viewer";
import { InvoiceBuilder } from "./invoice_builder";
import { MyModal } from "../features/RadConnStyle";

export default function InvoiceSelector(props) {
  const [winState, setWinState] = props.winState;
  const [pdfState, setPdfState] = useState({
    show: false,
    action: () => {},
    data: null,
    docu: null,
  });

  useEffect(() => {
    if (winState?.show) {
      console.log(winState?.data);
      setPdfState((p) => ({
        ...p,
        ...{ data: winState?.data },
      }));
    }
    return () => {};
  }, [winState?.show]);

  const handleClose = () => {
    setWinState((p) => ({ ...p, ...{ show: false } }));
  };

  const handlePdfState = (value) => {
    setPdfState((p) => ({
      ...p,
      ...{
        show: value,
        docu: <InvoiceBuilder {...{ ...winState }} />,
      },
    }));
  };

  return (
    <MyModal show={winState.show}>
      <ModalHeader closeButton onHide={handleClose}></ModalHeader>
      <ModalBody>
        <Button onClick={() => handlePdfState(true)}>Priview</Button>
      </ModalBody>
      <ModalFooter></ModalFooter>
      <PDFViewerTool
        {...{
          winState: [pdfState, setPdfState],
        }}
      ></PDFViewerTool>
    </MyModal>
  );
}
